import { useDefaultObservableBoolean } from "observables/BooleanObservable";
import { useDefaultObservableNumber } from "observables/NumberObservable";
import { useEffect } from "packages/react";
import { useTranslation } from "react-i18next";
import { createComponent } from "utils/libExtend/createComponent";

import { Controls } from "./Controls/Controls.component";
import { ControlsSelect } from "./ControlsSelect/ControlsSelect.component";
import { TableNavigationProps } from "./TableNavigation.props";
import { STableNavigation } from "./TableNavigationStyled/STableNavigation.styled";
import { STableNavigationTotalPages } from "./TableNavigationStyled/STableNavigationTotalPages.styled";
import { STableNavigationTotalPagesDescription } from "./TableNavigationStyled/STableNavigationTotalPagesDescription.styled";
import { STableNavigationTotalPagesValue } from "./TableNavigationStyled/STableNavigationTotalPagesValue.styled";

export const TableNavigation = createComponent<TableNavigationProps>("TableNavigation", (props) => {
  const { t, i18n } = useTranslation();
  const { service } = props;

  useEffect(() => {
    service.controller.onChangeArabic(i18n.language === "ar");
  }, [i18n.language]);

  const totalPages = useDefaultObservableNumber(service.state.totalPages);

  const totalElements = useDefaultObservableNumber(service.state.totalElements);

  const isArabic = useDefaultObservableBoolean(service.state.isArabic);

  return (
    <STableNavigation isArabic={isArabic}>
      {service.state.showCountElements && (
        <STableNavigationTotalPages isArabic={isArabic}>
          <STableNavigationTotalPagesDescription>{t("tableNavigation.totalPageTitle")}</STableNavigationTotalPagesDescription>
          <STableNavigationTotalPagesValue isArabic={isArabic}>{totalPages}</STableNavigationTotalPagesValue>
        </STableNavigationTotalPages>
      )}
      {service.state.showCountElements && (
        <STableNavigationTotalPages isArabic={isArabic}>
          <STableNavigationTotalPagesDescription>{t("tableNavigation.totalOperationsTitle")}</STableNavigationTotalPagesDescription>
          <STableNavigationTotalPagesValue isArabic={isArabic}>{totalElements}</STableNavigationTotalPagesValue>
        </STableNavigationTotalPages>
      )}
      <Controls service={service} />
      <ControlsSelect service={service} />
    </STableNavigation>
  );
});
